import React, { ComponentType } from 'react'
import style from './style/FontRulersContainer.scss'
import FontRuler from './FontRuler'

type FontRulersContainerProps = {
	fontsList: Array<string>
	onFontLoaded: (fontFamily: string) => void
	viewMode: string
}
export const FontRulersContainer: ComponentType<FontRulersContainerProps> = ({ fontsList, onFontLoaded, viewMode }) => {
	if (!fontsList.length) {
		return null
	}

	return (
		<div id="FONTS" className={style.fontRulerContainer}>
			{fontsList.map((fontFamily) => (
				// add viewMode to key to force re-render on viewMode change
				<FontRuler key={`${fontFamily}-${viewMode}`} fontFamily={fontFamily} onFontLoaded={onFontLoaded} />
			))}
		</div>
	)
}

export default FontRulersContainer
